import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const duo: Collection = {
  id: 'ona-duo',
  brandId: 'ona',
  brandName: 'Ona',
  icon: 'ona.png',
  title: 'Duo',
  subTitle: 'Speels & kleurrijk',
  banner: 'duo/duo-banner.jpg',
  items: [
    {
      id: 'ona-duo-1',
      collectionImages: [
        {
          image: 'duo/Duo_8.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'duo/Duo_9.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'duo/Duo_10.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'ona-duo-2',
      collectionImages: [
        {
          image: 'duo/Duo.jpg',
          width: CollectionBannerWidth['66%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'duo/Duo_1.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'ona-duo-3',
      collectionImages: [
        {
          image: 'duo/Duo_11.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'duo/Duo_3.jpg',
          width: CollectionBannerWidth['66%'],
          fullHeight: false,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    '521426b4-43f0-433a-a708-a90a2c9e5ef9',
    'e989bfb9-50a9-4a68-b02f-92616ec9ddb6',
    'b8f5c653-b769-4a76-a471-bec2798ef801',
    '23e58641-dd39-4b2e-99d4-1805ec3c66a4',
    '20e747a7-d589-4341-b043-783b85cd407f',
    '7a79b8c7-a39d-4f09-a5ba-8832ffb74890',
    'd097a18a-db69-4cfb-8dc6-ab2b817f1136',
    '6a7ee79e-cab6-4d1d-be4f-4ce3e590e949',
    '43f7a474-5e36-445f-ac04-9191cba49599',
    '61a4d2fd-83e0-4c59-9c70-0bc648ea4ddc',
    'cf609a09-d429-4763-91e0-7e1c0e2f5557',
    'be4a60d6-86c1-406d-8e6d-c0cd1200cadd',
    'e1e96016-9718-49d6-b9bd-f46c9bb4b79f',
    'c2a6073c-d171-44ff-aa58-9bcb614f47c4',
    '46146279-6b3f-4ba1-82cb-aef09b2c417e',
    '3c3df970-3267-4565-8896-06b357d9a1d6',
    'c1349709-a223-45a2-be18-40e08e21220e',
    '1609c185-d0c1-4dcc-999c-d3434483b16e',
    '206612db-7f18-45b4-985f-f12babc1287b',
    '062c21a8-747d-48b6-adbc-0097a404ce46',
    '4236f151-50f1-4d3d-b49f-32c9c6fc79ea',
    'be170ae8-1314-4ba9-9874-6dc711609499',
    '49608ecd-1ea2-48b9-8fa3-4e04c53dc0e3',
    '1b08eb4b-4a69-4fb7-a345-27c0b7d61714',
    '98e81451-9d76-4f37-883b-f29e97a43648',
    '2dfabd89-abde-4cd4-946f-a5a21c0a9a8c'
  ]
};
